module.exports = __webpack_public_path__ + "img/logout.e1b945bf.svg";